import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [formData, setFormData] = useState({
        username: 'king_superadmin@gmail.com',
        password: '12345'
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { login, isAuthenticated, loading: authLoading } = useAuth();
    const navigate = useNavigate();

    // Redirect if already authenticated
    useEffect(() => {
        if (isAuthenticated && !authLoading) {
            navigate('/dashboard', { replace: true });
        }
    }, [isAuthenticated, authLoading, navigate]);

    // Show loading while checking auth
    if (authLoading) {
        return (
            <Container fluid className="golf-bg min-vh-100 d-flex align-items-center justify-content-center">
                <Spinner animation="border" variant="light" />
            </Container>
        );
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!formData.username || !formData.password) {
            setError('Please fill in all fields');
            setLoading(false);
            return;
        }

        try {
            const result = await login(formData.username, formData.password);

            if (result.success) {
                navigate('/dashboard', { replace: true });
            } else {
                setError(result.error || 'Login failed. Please try again.');
            }
        } catch (err) {
            setError('An unexpected error occurred. Please try again.');
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container fluid className="golf-bg min-vh-100 d-flex align-items-center justify-content-center py-4 position-relative overflow-hidden">
            {/* Golf-themed floating shapes with higher visibility */}
            <div className="golf-shape golf-flag flag-red" style={{ top: '10%', left: '15%' }}>🚩</div>
            <div className="golf-shape golf-club" style={{ top: '20%', right: '12%' }}>🏌️‍♂️</div>
            <div className="golf-shape golf-ball ball-white" style={{ bottom: '15%', left: '25%' }}>⚪</div>
            <div className="golf-shape golf-hole hole-yellow" style={{ top: '35%', left: '8%' }}>⛳</div>
            <div className="golf-shape golf-trophy" style={{ bottom: '20%', right: '15%' }}>🏆</div>
            <div className="golf-shape golf-cart" style={{ top: '5%', right: '8%' }}>🛒</div>
            <div className="golf-shape golf-ball ball-yellow" style={{ bottom: '35%', right: '25%' }}>🟡</div>
            <div className="golf-shape golf-flag flag-blue" style={{ top: '65%', right: '10%' }}>🚩</div>
            <div className="golf-shape golf-tee" style={{ top: '45%', left: '85%' }}>🎯</div>
            <div className="golf-shape golf-bag" style={{ bottom: '5%', left: '10%' }}>🎒</div>

            {/* Additional golf elements */}
            <div className="golf-shape golf-scorecard" style={{ top: '75%', left: '15%' }}>📝</div>
            <div className="golf-shape golf-glove" style={{ top: '25%', left: '40%' }}>🧤</div>
            <div className="golf-shape golf-putter" style={{ bottom: '45%', left: '60%' }}>🏌️</div>

            {/* Animated floating lines (golf course fairway) */}
            <div className="fairway-line" style={{ top: '20%', left: '0', animationDelay: '0s' }}></div>
            <div className="fairway-line" style={{ top: '40%', left: '0', animationDelay: '1s' }}></div>
            <div className="fairway-line" style={{ top: '60%', left: '0', animationDelay: '2s' }}></div>
            <div className="fairway-line" style={{ top: '80%', left: '0', animationDelay: '3s' }}></div>

            {/* Floating dots representing grass/terrain */}
            <div className="grass-dot" style={{ top: '30%', left: '20%' }}></div>
            <div className="grass-dot" style={{ top: '50%', left: '40%' }}></div>
            <div className="grass-dot" style={{ top: '70%', left: '60%' }}></div>
            <div className="grass-dot" style={{ top: '40%', left: '80%' }}></div>
            <div className="grass-dot" style={{ top: '60%', left: '30%' }}></div>

            <Container>
                <Row className="justify-content-center">
                    <Col md={6} lg={4}>
                        <Card className="shadow-lg border-0 glass-card">
                            <Card.Body className="p-4">
                                <div className="text-center mb-4">
                                    <h2 className="text-success fw-bold mb-2">🛒 Golf Cart</h2>
                                    <p className="text-muted mb-0">Admin Dashboard</p>
                                </div>

                                {error && (
                                    <Alert variant="danger" className="mb-3">
                                        {error}
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">Email or Username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="username"
                                            value={formData.username}
                                            onChange={handleChange}
                                            placeholder="Enter your email or username"
                                            required
                                            disabled={loading}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-4">
                                        <Form.Label className="fw-semibold">Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            placeholder="Enter your password"
                                            required
                                            disabled={loading}
                                        />
                                    </Form.Group>

                                    <Button
                                        variant="success"
                                        type="submit"
                                        className="w-100 py-2 fw-semibold"
                                        disabled={loading}
                                        size="lg"
                                    >
                                        {loading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="me-2"
                                                />
                                                Signing in...
                                            </>
                                        ) : (
                                            'Sign In'
                                        )}
                                    </Button>
                                </Form>

                                <div className="text-center mt-4">
                                    <small className="text-muted">
                                        Demo Credentials:<br />
                                        <strong>Username/Email:</strong> king_superadmin@gmail.com<br />
                                        <strong>Password:</strong> 12345
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <style jsx>{`
                .golf-bg {
                    background: linear-gradient(135deg, #0d3b1e 0%, #155724 25%, #1e7e34 50%, #28a745 75%, #20c997 100%);
                    position: relative;
                }
                
                .golf-bg::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-image: 
                        radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.15) 3px, transparent 3px),
                        radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.15) 3px, transparent 3px),
                        radial-gradient(circle at 40% 80%, rgba(255, 255, 255, 0.15) 3px, transparent 3px),
                        radial-gradient(circle at 60% 20%, rgba(255, 255, 255, 0.15) 3px, transparent 3px);
                    background-size: 150px 150px;
                    opacity: 0.4;
                }
                
                .golf-shape {
                    position: absolute;
                    font-size: 2.5rem;
                    opacity: 0.8;
                    animation: float 20s infinite ease-in-out;
                    z-index: 0;
                    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3));
                    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
                }
                
                /* Specific element styles for better visibility */
                .golf-ball {
                    background: white;
                    border-radius: 50%;
                    width: 50px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    box-shadow: 0 0 20px rgba(255, 255, 255, 0.7);
                }
                
                .ball-white {
                    background: white;
                    color: #333;
                }
                
                .ball-yellow {
                    background: #FFD700;
                    color: #333;
                }
                
                .golf-flag {
                    font-size: 2.2rem;
                    animation: floatFlag 15s infinite ease-in-out;
                }
                
                .flag-red {
                    color: #FF0000;
                    text-shadow: 2px 2px 8px rgba(255, 0, 0, 0.6);
                }
                
                .flag-blue {
                    color: #1E90FF;
                    text-shadow: 2px 2px 8px rgba(30, 144, 255, 0.6);
                }
                
                .golf-club {
                    font-size: 2.8rem;
                    animation: floatClub 18s infinite ease-in-out;
                    color: #8B4513;
                    text-shadow: 2px 2px 8px rgba(139, 69, 19, 0.6);
                }
                
                .golf-trophy {
                    font-size: 2.5rem;
                    animation: floatTrophy 25s infinite ease-in-out;
                    color: #FFD700;
                    text-shadow: 2px 2px 10px rgba(255, 215, 0, 0.7);
                }
                
                .golf-cart {
                    font-size: 3rem;
                    animation: floatCart 35s infinite linear;
                    color: #FF4500;
                    text-shadow: 2px 2px 10px rgba(255, 69, 0, 0.7);
                }
                
                .golf-hole {
                    font-size: 2.2rem;
                    animation: floatHole 20s infinite ease-in-out;
                }
                
                .hole-yellow {
                    color: #FFD700;
                    text-shadow: 2px 2px 8px rgba(255, 215, 0, 0.7);
                }
                
                .golf-tee {
                    font-size: 2rem;
                    animation: floatTee 22s infinite ease-in-out;
                    color: #00FF00;
                    text-shadow: 2px 2px 8px rgba(0, 255, 0, 0.6);
                }
                
                .golf-bag {
                    font-size: 2.3rem;
                    animation: floatBag 20s infinite ease-in-out;
                    color: #4169E1;
                    text-shadow: 2px 2px 8px rgba(65, 105, 225, 0.6);
                }
                
                .golf-scorecard {
                    font-size: 2rem;
                    animation: floatScore 18s infinite ease-in-out;
                    color: #FFFFFF;
                    text-shadow: 2px 2px 8px rgba(255, 255, 255, 0.7);
                }
                
                .golf-glove {
                    font-size: 2.2rem;
                    animation: floatGlove 20s infinite ease-in-out;
                    color: #FFFFFF;
                    text-shadow: 2px 2px 8px rgba(255, 255, 255, 0.7);
                }
                
                .golf-putter {
                    font-size: 2.5rem;
                    animation: floatPutter 19s infinite ease-in-out;
                    color: #8B4513;
                    text-shadow: 2px 2px 8px rgba(139, 69, 19, 0.6);
                }
                
                .fairway-line {
                    position: absolute;
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
                    animation: fairwayFlow 10s infinite linear;
                    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
                }
                
                .grass-dot {
                    position: absolute;
                    width: 8px;
                    height: 8px;
                    background: #32CD32;
                    border-radius: 50%;
                    opacity: 0.6;
                    animation: grassFloat 15s infinite ease-in-out;
                    box-shadow: 0 0 10px #32CD32;
                }
                
                .glass-card {
                    background: rgba(255, 255, 255, 0.98);
                    backdrop-filter: blur(15px);
                    border: 1px solid rgba(255, 255, 255, 0.4);
                    z-index: 2;
                    position: relative;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
                }
                
                /* Animations */
                @keyframes float {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    33% {
                        transform: translateY(-30px) rotate(120deg);
                    }
                    66% {
                        transform: translateY(30px) rotate(240deg);
                    }
                }
                
                @keyframes floatBall {
                    0% {
                        transform: translate(0, 0) rotate(0deg);
                        box-shadow: 0 0 25px rgba(255, 255, 255, 0.9);
                    }
                    25% {
                        transform: translate(120px, -80px) rotate(90deg);
                        box-shadow: 0 0 30px rgba(255, 255, 255, 1);
                    }
                    50% {
                        transform: translate(80px, 120px) rotate(180deg);
                        box-shadow: 0 0 25px rgba(255, 255, 255, 0.9);
                    }
                    75% {
                        transform: translate(-80px, 80px) rotate(270deg);
                        box-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
                    }
                    100% {
                        transform: translate(0, 0) rotate(360deg);
                        box-shadow: 0 0 25px rgba(255, 255, 255, 0.9);
                    }
                }
                
                @keyframes floatFlag {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg) scale(1);
                    }
                    25% {
                        transform: translateY(-40px) rotate(-5deg) scale(1.1);
                    }
                    50% {
                        transform: translateY(20px) rotate(5deg) scale(1);
                    }
                    75% {
                        transform: translateY(-20px) rotate(-5deg) scale(1.05);
                    }
                }
                
                @keyframes floatClub {
                    0%, 100% {
                        transform: translate(0, 0) rotate(0deg);
                    }
                    50% {
                        transform: translate(80px, -50px) rotate(360deg);
                    }
                }
                
                @keyframes floatTrophy {
                    0%, 100% {
                        transform: scale(1) rotate(0deg);
                    }
                    25% {
                        transform: scale(1.3) rotate(10deg);
                    }
                    50% {
                        transform: scale(1.2) rotate(0deg);
                    }
                    75% {
                        transform: scale(1.25) rotate(-10deg);
                    }
                }
                
                @keyframes floatCart {
                    0% {
                        transform: translateX(-150px) rotate(0deg);
                    }
                    100% {
                        transform: translateX(100vw) rotate(720deg);
                    }
                }
                
                @keyframes floatHole {
                    0%, 100% {
                        transform: scale(1);
                    }
                    50% {
                        transform: scale(1.5);
                    }
                }
                
                @keyframes floatTee {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-50px) rotate(180deg);
                    }
                }
                
                @keyframes floatBag {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(40px) rotate(180deg);
                    }
                }
                
                @keyframes floatScore {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-30px) rotate(10deg);
                    }
                }
                
                @keyframes floatGlove {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-35px) rotate(15deg);
                    }
                }
                
                @keyframes floatPutter {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(30px) rotate(180deg);
                    }
                }
                
                @keyframes fairwayFlow {
                    0% {
                        transform: translateX(-100%);
                    }
                    100% {
                        transform: translateX(100%);
                    }
                }
                
                @keyframes grassFloat {
                    0%, 100% {
                        transform: translateY(0) scale(1);
                        opacity: 0.6;
                    }
                    50% {
                        transform: translateY(-20px) scale(1.2);
                        opacity: 0.8;
                    }
                }
                
                @media (max-width: 768px) {
                    .golf-shape {
                        font-size: 2rem;
                        opacity: 0.9;
                    }
                    
                    .golf-ball {
                        width: 40px;
                        height: 40px;
                        font-size: 1.2rem;
                    }
                }
            `}</style>
        </Container>
    );
};

export default Login;